import { render, staticRenderFns } from "./IssuePageWordsmart.vue?vue&type=template&id=30e9046e&scoped=true&"
import script from "./IssuePageWordsmart.vue?vue&type=script&lang=ts&"
export * from "./IssuePageWordsmart.vue?vue&type=script&lang=ts&"
import style0 from "./IssuePageWordsmart.vue?vue&type=style&index=0&id=30e9046e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e9046e",
  null
  
)

export default component.exports